/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import wsSend_request from "../../../Api/ws/ws_request";
import { useSelector } from "react-redux";
import { WebSocketContext } from "../../../App";
import CommonTable from "../../Common/CommonTable";

const ErpStockLogs = (props) => {
    const [ Tab, setTab ] = useState("stock_level_list");
    const { websocket } = useContext(WebSocketContext);
    const { device_id, ErpStockLevelLogList, ErpStockDetailsLogList, selfInfo } = useSelector((state) => state.adminReducers);
    const [ userLimit, setUserLimit ] = useState(10);
    const [ currentPage, setCurrentPage ] = useState(1);
    const [ userLimit2, setUserLimit2 ] = useState(10);
    const [ currentPage2, setCurrentPage2 ] = useState(1);
    const PermissionsAccess = selfInfo?.user?.permissions_access;

    const APICall = () => {
        if(selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.Store[7]?.Edit || PermissionsAccess?.Store[7]?.View) {
            if(Tab === "stock_level_list") {
                let param = {
                    "transmit": "broadcast",
                    "url": "erp_store_level_log_list",
                    "request": {
                        "limit": userLimit,
                        "page_no": currentPage,
                    },
                    "DeviceId": device_id
                };
                wsSend_request(websocket, param);
            } else {
                let param = {
                    "transmit": "broadcast",
                    "url": "erp_store_frame_log_list",
                    "request": {
                        "limit": userLimit2,
                        "page_no": currentPage2,
                    },
                    "DeviceId": device_id
                };
                wsSend_request(websocket, param);
            };
        };
    };

    // API CALL FUNCTION
    useEffect(() => {
        APICall();
    }, [ websocket, currentPage, userLimit, currentPage2, userLimit2, Tab ]);

    // STOCK LEVEL CURRENT PAGE FUNCTION
    const currentFunction = (page) => {
        setCurrentPage(page);
    };

    // STOCK LEVEL LIMIT FUNCTION
    const SelectLimitFct = (e) => {
        setUserLimit(parseInt(e.target.value));
        setCurrentPage(1);
    };

    // STOCK DETAILS CURRENT PAGE FUNCTION
    const currentFunction2 = (page) => {
        setCurrentPage2(page);
    };

    // STOCK DETAILS LIMIT FUNCTION
    const SelectLimitFct2 = (e) => {
        setUserLimit2(parseInt(e.target.value));
        setCurrentPage2(1);
    };

    // TABLE COLUMNS ARRAY
    const TableColumns = [
        { key: 'updated_at', label: 'Updated On', type: "date_time", sort: "", isCollapsable: false },
    ];

    return (<section className="Main_section" id="Main_section_Erp_Stock_Logs" style={{ position: "relative" }}>
        <div className="MainHeader">
            <ul className="MainHeader_Tab">
                <li className={Tab === "stock_level_list" ? "active" : ""} onClick={() => setTab("stock_level_list")}>Stock Level</li>
                <li className={Tab === "stock_details_report" ? "active" : ""} onClick={() => setTab("stock_details_report")}>Stock Details</li>
            </ul>
        </div>
        <React.Fragment>
            {Tab === "stock_level_list" ? (<React.Fragment>
                <div className="filtr_Form" style={{ position: "absolute", top: "-8px", right: "0", width: "auto", marginBottom: "0px" }}>
                    <div className="formloginset">
                        <div className="row" style={{ justifyContent: "flex-end" }}>
                            <div className="col-md-3" style={{ display: "flex", alignItems: "center", width: "auto" }}>
                                <select 
                                    className="form-control userLimitselect" 
                                    id="userLimitselect" 
                                    value={userLimit} 
                                    onChange={(e) => SelectLimitFct(e)}
                                >
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="60">60</option>
                                    <option value="70">70</option>
                                    <option value="80">80</option>
                                    <option value="90">90</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                {/* COMMON TABLE */}
                <CommonTable 
                    isTableAllow={true}
                    style={{
                        height: parseInt(ErpStockLevelLogList?.pagination?.total_records) === ErpStockLevelLogList?.list?.length ? "calc(100vh - 135px)" : parseInt(ErpStockLevelLogList?.pagination?.total_records) > 10 ? "calc(100vh - 170px)" : "calc(100vh - 135px)"
                    }}
                    srNumber={{
                        clickable: false,
                        events: ""
                    }}
                    isCollapsable={false}
                    tabName={""} // TAB URL
                    PaginationCurrentPage={currentPage} // TAB CURRENT PAGE
                    PaginationFunction={currentFunction} // PAGINATION CHNAGE FUNCTION
                    TableColumns={TableColumns} // TABLE COLLUMNS & ROWS
                    OrderList={ErpStockLevelLogList} // ORDER LIST
                    Pagination={ErpStockLevelLogList?.pagination} // CURRENT TAB PAGINATION
                    EditAccess={false} // EDITABLE ACCESS STATE
                    APIcalling={""}
                    isActionPreviewAvailable={{
                        isShow: selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.Store[7]?.Edit,
                        url: "erp_store_level_log_view",
                    }}
                    isActionColumnAvailable={{
                        isShow: false,
                        label: "",
                        naviagte: null
                    }}
                    isActionTwoColumnAvailable={{
                        isShow: false,
                        url: "",
                    }}
                    isTotalAndGrand={{
                        isShow: false,
                        filterType: "",
                        colSpan: 0,
                        lastColspan: 0
                    }}
                    isOdiFilterRowColorsAllow={false}
                />
            </React.Fragment>) : (<React.Fragment>
                <div className="filtr_Form" style={{ position: "absolute", top: "-8px", right: "0", width: "auto", marginBottom: "0px" }}>
                    <div className="formloginset">
                        <div className="row" style={{ justifyContent: "flex-end" }}>
                            <div className="col-md-3" style={{ display: "flex", alignItems: "center", width: "auto" }}>
                                <select 
                                    className="form-control userLimitselect" 
                                    id="userLimitselect" 
                                    value={userLimit2} 
                                    onChange={(e) => SelectLimitFct2(e)}
                                >
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="60">60</option>
                                    <option value="70">70</option>
                                    <option value="80">80</option>
                                    <option value="90">90</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                {/* COMMON TABLE */}
                <CommonTable 
                    isTableAllow={true}
                    style={{
                        height: parseInt(ErpStockDetailsLogList?.pagination?.total_records) === ErpStockDetailsLogList?.list?.length ? "calc(100vh - 135px)" : parseInt(ErpStockDetailsLogList?.pagination?.total_records) > 10 ? "calc(100vh - 170px)" : "calc(100vh - 135px)"
                    }}
                    srNumber={{
                        clickable: false,
                        events: ""
                    }}
                    isCollapsable={false}
                    tabName={""} // TAB URL
                    PaginationCurrentPage={currentPage2} // TAB CURRENT PAGE
                    PaginationFunction={currentFunction2} // PAGINATION CHNAGE FUNCTION
                    TableColumns={TableColumns} // TABLE COLLUMNS & ROWS
                    OrderList={ErpStockDetailsLogList} // ORDER LIST
                    Pagination={ErpStockDetailsLogList?.pagination} // CURRENT TAB PAGINATION
                    EditAccess={false} // EDITABLE ACCESS STATE
                    APIcalling={""}
                    isActionPreviewAvailable={{
                        isShow: selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.Store[7]?.Edit,
                        url: "erp_store_details_log_view",
                    }}
                    isActionColumnAvailable={{
                        isShow: false,
                        label: "",
                        naviagte: null
                    }}
                    isActionTwoColumnAvailable={{
                        isShow: false,
                        url: "",
                    }}
                    isTotalAndGrand={{
                        isShow: false,
                        filterType: "",
                        colSpan: 0,
                        lastColspan: 0
                    }}
                    isOdiFilterRowColorsAllow={false}
                />
            </React.Fragment>)}
        </React.Fragment>
    </section>)
}

export default ErpStockLogs;